"use strict";
/**
 * Trust Check Type Definitions
 * Recipient email address trust level assessment for DFFiles
 *
 * Requirements: 17.1, 17.2, 17.4
 *
 * Trust Level Definitions:
 * - Level 1: Registered contact (連絡先登録済み)
 * - Level 2: Interaction history exists (やり取り履歴あり)
 * - Level 3: Known domain (既知ドメイン)
 * - Level 4: New domain (新規ドメイン)
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrustValidation = exports.TRUST_LEVEL_CONFIGS = void 0;
/**
 * Pre-configured trust level display settings
 * Used by frontend RecipientChip component to render trust indicators
 */
exports.TRUST_LEVEL_CONFIGS = {
    1: {
        level: 1,
        label: '連絡先登録済み',
        icon: 'shield-check',
        colorScheme: 'green',
    },
    2: {
        level: 2,
        label: 'やり取り履歴あり',
        icon: 'history',
        colorScheme: 'blue',
    },
    3: {
        level: 3,
        label: '同ドメインの連絡先あり',
        icon: 'info-circle',
        colorScheme: 'orange',
        tooltipTemplate: 'このドメインの連絡先とやり取り履歴がありますが、このアドレスは初めてです',
    },
    4: {
        level: 4,
        label: '新規ドメイン',
        icon: 'exclamation-triangle',
        colorScheme: 'red',
        tooltipTemplate: '初めてのドメインです。送信先を確認してください',
    },
};
// ============================================================================
// Validation Rules (Constants)
// ============================================================================
/**
 * Trust check validation rules
 */
exports.TrustValidation = {
    MAX_EMAILS_PER_REQUEST: 100,
    MIN_EMAILS_PER_REQUEST: 1,
    DEBOUNCE_MS: 300, // Frontend debounce interval for API calls
};
//# sourceMappingURL=trust.js.map